import BaseCtrl from 'edge/platform/base/BaseCtrl';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';

var fn = function fn($filter, $scope, $state, $stateParams, $window, ModalService, AccountService, NewAccountService, defaultLocaleDetails, ViewModelService, PolicyService, LocaleService) {
    var ctrl = Object.create(BaseCtrl);
    var feinTest = /^[1-9]\d?-\d{7}$/;
    var addressConfig = LocaleService.getAddressConfig();
    ctrl.init = function () {
        $scope.hideFields = ['AddressLine1', 'AddressLine2', 'AddressLine3'];
        if ($stateParams.accountNumber && $stateParams.accountNumber.length > 0) {
            $scope.accountNumber = $stateParams.accountNumber;
            $scope.isExistingAccount = true;
        } else {
            $scope.isExistingAccount = false;
        }
        PolicyService.callEUTS('New Quote Account Search', 'Submit Application', '');
        var defaultCountryCode = $scope.defaultCountryCode || defaultLocaleDetails.countryCode;

        $scope.showResults = false;
        $scope.emptyFlag = false;
        $scope.showResultsTable = false;

        $scope.address = {};
        $scope.accountSearchCriteria = {};
        $scope.accountSearchCriteria.country = defaultCountryCode;
        $scope.accountSearchCriteriaView = ViewModelService.create($scope.accountSearchCriteria, 'pc', 'edge.capabilities.gateway.account.search.dto.AccountSearchCriteriaDTO');
        console.log("account search");console.log($scope.accountSearchCriteriaView);
        /*if($scope.accountSearchCriteriaView.country.value.code == 'US'){
        	$scope.selected = {   "type": "select",                     		    
        		    "value": "MT", 
        		    "availableStates": [{"name":"Montana","code":"MT"},{"name":"Alabama","code":"AL"},{"name":"Alaska","code":"AK"},{"name":"Arizona","code":"AZ"},{"name":"Arkansas","code":"AR"},{"name":"California","code":"CA"},{"name":"Colorado","code":"CA"},{"name":"Connecticut","code":"CT"},{"name":"Delaware","code":"DE"},{"name":"District of Columbia","code":"DC"},{"name":"Florida","code":"FL"},{"name":"Georgia","code":"GA"},{"name":"Hawaii","code":"HI"},{"name":"Idaho","code":"ID"},{"name":"Illinois","code":"IL"},{"name":"Indiana","code":"IN"},{"name":"Iowa","code":"IA"},{"name":"Kansas","code":"KS"},{"name":"Kentucky","code":"KY"},{"name":"Louisiana","code":"LA"},{"name":"Maine","code":"ME"},{"name":"Maryland","code":"MD"},{"name":"Massachusetts","code":"MA"},{"name":"Michigan","code":"MI"},{"name":"Minnesota","code":"MN"},{"name":"Mississippi","code":"MS"},{"name":"Missouri","code":"MO"},{"name":"Nebraska","code":"NE"},{"name":"Nevada","code":"NV"},{"name":"New Hampshire","code":"NH"},{"name":"New Jersey","code":"NJ"},{"name":"New Mexico","code":"NM"},{"name":"New York","code":"NY"},{"name":"North Carolina","code":"NC"},{"name":"North Dakota","code":"ND"},{"name":"Ohio","code":"OH"},{"name":"Oklahoma","code":"OK"},{"name":"Oregon","code":"OR"},{"name":"Pennsylvania","code":"PA"},{"name":"Puerto Rico","code":"PR"},{"name":"Rhode Island","code":"RI"},{"name":"South Carolina","code":"SC"},{"name":"South Dakota","code":"SD"},{"name":"Tennessee","code":"TN"},{"name":"Texas","code":"TX"},{"name":"Utah","code":"UT"},{"name":"Vermont","code":"VT"},{"name":"Virginia","code":"VA"},{"name":"Washington","code":"WA"},{"name":"West Virginia","code":"WV"},{"name":"Wisconsin","code":"WI"},{"name":"Wyoming","code":"WY"}] 
        		  };
        	
        	$scope.selected.value = $scope.selected.availableStates[0].code;
        }*/
        $scope.potentialAccounts = [];

        $scope.newAccount = {
            ProducerCode: '100-002541'
        };
        $scope.newAccount.AccountHolder = {};

        $scope.showAccessAlert = true;

        $scope.hideAccessAlert = function () {
            $scope.showAccessAlert = false;
        };

        var applicationFeatures = ApplicationFeatures.getAllFeatures();
        $scope.accountTypes = applicationFeatures.accountTypes;
        $scope.accountSearchCriteria.contactType = applicationFeatures.accountTypes[0];
    };

    $scope.is_usZipCode = function (value) {
        var regexp = /^[0-9a-zA-Z]{5}(?:-[0-9a-zA-Z]{4})?$/;
        if (value && regexp.test(value)) {
            $scope.error_exist = false;
        } else {
            $scope.error_exist = true;
        }
    };

    $scope.is_auZipCode = function (value) {
        var regexp = /^[0-9]{4}$/;
        if (value && regexp.test(value)) {
            $scope.error_exist = false;
        } else {
            $scope.error_exist = true;
        }
    };

    //for canada country
    $scope.is_caZipCode = function (value) {
        //var regexp = /^[0-9a-zA-Z]{3}(?:[ ][0-9a-zA-Z]{3})?$/;
        var regexp = /^[A-Z]\d[A-Z][ -]?\d[A-Z]\d$/;
        if (value && regexp.test(value)) {
            $scope.error_exist = false;
        } else $scope.error_exist = true;
    };

    $scope.$watch('accountSearchCriteriaView.postalCode.value', function (value) {
        if ($scope.accountSearchCriteriaView.country.value.code != 'CA' && $scope.accountSearchCriteriaView.country.value.code != 'AU' && $scope.accountSearchCriteriaView.postalCode.value != undefined) $scope.is_usZipCode(value);
        if ($scope.accountSearchCriteriaView.country.value.code == 'CA' && $scope.accountSearchCriteriaView.postalCode.value != undefined) $scope.is_caZipCode(value);
        if ($scope.accountSearchCriteriaView.country.value.code == 'AU' && $scope.accountSearchCriteriaView.postalCode.value != undefined) $scope.is_usZipCode(value);
    });

    $scope.$watch('accountSearchCriteriaView.country.value', function (value) {
        console.log("country changes");console.log(value);
        if ($scope.accountSearchCriteriaView.country.value.code == 'US') {
            console.log(value.code);
            var StateListPromise = AccountService.getStates(value.code);
            StateListPromise.then(function (data) {

                $scope.availableStates = [];
                angular.forEach(data, function (result, resultkey) {
                    $scope.result = result.split('~');
                    $scope.availableStates.push($scope.result);
                });
                $scope.desiredArray = [];
                angular.forEach($scope.availableStates, function (splitedvalues) {
                    console.log(splitedvalues);
                    $scope.desiredArray.push({ name: splitedvalues[0], code: splitedvalues[1] });
                });
                //console.log(scope.selected);
                $scope.selected = {
                    "value": $scope.desiredArray[0],
                    "availableStates": $scope.desiredArray
                };
                //console.log(scope.selected.availableStates[0].code)

                //scope.selected.value = 'MT';
                //$scope.accountSearchCriteriaView.state.value = $scope.selected.availableStates[0].code;
            });
        }
        if ($scope.accountSearchCriteriaView.country.value.code == 'AU') {
            console.log(value.code);
            var _StateListPromise = AccountService.getStates(value.code);
            _StateListPromise.then(function (data) {

                $scope.availableStates = [];
                angular.forEach(data, function (result, resultkey) {
                    $scope.result = result.split('~');
                    $scope.availableStates.push($scope.result);
                });
                $scope.desiredArray = [];
                angular.forEach($scope.availableStates, function (splitedvalues) {
                    console.log(splitedvalues);
                    $scope.desiredArray.push({ name: splitedvalues[0], code: splitedvalues[1] });
                });
                //console.log(scope.selected);
                $scope.selected = {
                    "value": $scope.desiredArray[0],
                    "availableStates": $scope.desiredArray
                };
                //console.log(scope.selected.availableStates[0].code)

                //scope.selected.value = 'MT';
                //$scope.accountSearchCriteriaView.state.value = $scope.selected.availableStates[0].code;
            });
        }
        /*if($scope.accountSearchCriteriaView.country.value.code == 'CA'){
        	console.log(value.code);
        	const StateListPromise = AccountService.getStates(value.code);
              	StateListPromise.then((data) => {
              		
              		
              		$scope.availableStates=[];
              		angular.forEach(data,function(result,resultkey){
                  		$scope.result = result.split('~');
                  		$scope.availableStates.push($scope.result);
                  		
                  	});	
              		$scope.desiredArray=[]
                  	angular.forEach($scope.availableStates, function(splitedvalues){
                  		console.log(splitedvalues)
                  		$scope.desiredArray.push({name: splitedvalues[0], code: splitedvalues[1]});
                  	});
                  	//console.log(scope.selected);
                  	$scope.selected = { 
                  	"value":$scope.desiredArray[0],
          		    "availableStates": $scope.desiredArray 
          		  };
                  	//console.log(scope.selected.availableStates[0].code)
               	
                  	//scope.selected.value = 'MT';
               	//$scope.accountSearchCriteriaView.state.value = $scope.selected.availableStates[0].code;
                  });
              	
        }
        if($scope.accountSearchCriteriaView.country.value.code != 'US' && $scope.accountSearchCriteriaView.country.value.code != 'CA'){
              	$scope.selected.value = '';
              	$scope.accountSearchCriteriaView.state.value = '';
              	//if(value.length == 0){
        	//	delete($scope.accountSearchCriteriaView.state);
        	//}
              }*/
    });

    $scope.selectedState = function (selected) {
        console.log(selected);
        //if(selected =='Montana')
        $scope.accountSearchCriteriaView.state.value = selected.code;
    };

    ctrl.getSearchResult = function () {
        return JSON.stringify($scope.accountSearchCriteria);
    };

    ctrl.isVisible = function (fieldName) {
        var visible = addressConfig.fieldNames.indexOf(fieldName) >= 0;
        if ($scope.hideFields) {
            visible = visible && !(_.contains($scope.hideFields, fieldName) || _.contains(_.map($scope.hideFields, function (idx) {
                return idx + 'Kanji';
            }), fieldName));
        }
        return visible;
    };

    ctrl.setCancelState = function () {
        var title = 'gateway.controllers.NewQuoteCtrl.Cancel Quote';
        var msg = 'gateway.controllers.NewQuoteCtrl.Are you sure you want to cancel the new quote?';
        var description = null;

        var cancelDialogPromise = ModalService.showWarning(title, msg, description, $filter('translate')('gateway.views.modal.Yes'), 'gw-btn-primary', $filter('translate')('gateway.views.modal.No')).result;
        cancelDialogPromise.then(function () {
            history.back();
        });
    };

    ctrl.setNextState = function (form) {
        form.submitted = true;
        if (form.invalid) {
            return;
        }

        $scope.queryExistingAccounts();
    };

    ctrl.newQuote = function (accountNumber) {
        var state = $state.get('newQuote');
        NewAccountService.AccountSearchCriteria = $scope.accountSearchCriteria;
        if (!angular.isDefined(accountNumber)) {
            $state.transitionTo(state);
        } else {
            $state.transitionTo(state, {
                accountNumber: accountNumber
            });
        }
    };

    ctrl.resetSearch = function () {
        $scope.showResults = false;
    };

    ctrl.queryExistingAccounts = function () {
        /*Added to check if the FEIN entered is valid before calling backend service_MSF
          Added to check either the FEIN and company Name should be entered_MSF
        */
        if ($scope.accountSearchCriteriaView.mSFOfficialID_EXT.value == undefined && $scope.accountSearchCriteria.contactName == undefined) {
            $scope.emptyFlag = true;
        } else if ($scope.accountSearchCriteriaView.mSFOfficialID_EXT.value == undefined && $scope.accountSearchCriteria.contactName == '') {
            $scope.emptyFlag = true;
        } else if ($scope.accountSearchCriteriaView.mSFOfficialID_EXT.value == '' && $scope.accountSearchCriteria.contactName == undefined) {
            $scope.emptyFlag = true;
        } else if ($scope.accountSearchCriteriaView.mSFOfficialID_EXT.value == '' && $scope.accountSearchCriteria.contactName == '') {
            $scope.emptyFlag = true;
        } else {
            $scope.emptyFlag = false;
        }
        if ($scope.accountSearchCriteriaView.mSFOfficialID_EXT.value == undefined || $scope.accountSearchCriteriaView.mSFOfficialID_EXT.value == '') {
            //do nothing
        } else {
            if (feinTest.test($scope.accountSearchCriteriaView.mSFOfficialID_EXT.value) == false) {
                return;
            }
        }
        if ($scope.emptyFlag == true) return;
        var ExistingAccountQueryPromise = AccountService.getPotentialExistingAccounts($scope.accountSearchCriteria);
        $scope.existingAccountQueryPromise = ExistingAccountQueryPromise;

        ExistingAccountQueryPromise.then(function (potentialExistingAccounts) {
            $scope.potentialAccounts = potentialExistingAccounts;
            $scope.showResults = true;
            //Added to restrict the search criteria to greater than 4 characters_MSF
            if ($scope.accountSearchCriteria.contactName == undefined || $scope.accountSearchCriteria.contactName.length == 0 || $scope.accountSearchCriteria.contactName.length == -1) {
                $scope.showResultsTable = !!(potentialExistingAccounts && potentialExistingAccounts.length > 0);
            } else {
                $scope.showResultsTable = !!(potentialExistingAccounts && potentialExistingAccounts.length > 0 && $scope.accountSearchCriteria.contactName != undefined && $scope.accountSearchCriteria.contactName.length > 4);
            }
        }, function () {
            ModalService.showError('gateway.views.modal.Error', 'gateway.views.modal.Error.Data');
        });
    };

    return ctrl.create($scope);
};

fn.$inject = ['$filter', '$scope', '$state', '$stateParams', '$window', 'ModalService', 'AccountService', 'NewAccountService', 'defaultLocaleDetails', 'ViewModelService', 'PolicyService', 'LocaleService'];
export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/NewQuoteAccountSearchCtrl.js
// module id = 1676
// module chunks = 0